/**
 * List Schema of ResponsavelWebhook
 * @author Simpli CLI generator
 */
import {
  Helper,
  Schema,
  FieldSet,
  FieldComponent,
  Component,
} from 'simpli-web-sdk'
import {ResponsavelWebhook} from '@/model/resource/ResponsavelWebhook'

/* TODO: review generated schema */
export class ListResponsavelWebhookSchema extends Schema {
  readonly name = 'ListResponsavelWebhook'

  readonly fieldSet: FieldSet<ResponsavelWebhook> = {
    idWebhookPk: (): FieldComponent => ({
      is: Component.Render,
    }),
    responsavel: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.responsavel?.$id,
      },
    }),
    typeWebhook: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.typeWebhook?.$id,
      },
    }),
    url: (schema): FieldComponent => ({
      is: Component.RenderAnchor,
      bind: {
        href: schema.model.url,
        label: schema.model.url,
        target: '_blank',
      },
    }),
  }
}
